import { GetterTree } from 'vuex';
import TeamMemberStateType from './authenticationStateType';

export const getters: GetterTree<TeamMemberStateType, any> = {
  grantedPermissions: (state) => state.grantedPermissions,
};
